import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';

const McpLoading = observer((props) => {
  const {
    className = '',
  } = props;

  return (
    <div className={`size-full relative overflow-visible ${className}`}>
      <div className="w-20/16 h-20/16 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" style={{
        background : `url(https://p1.ssl.qhimg.com/t11098f6bcd608751372d1c0dbd.png) center center / 100% 100% no-repeat`,
      }}></div>
    </div>
  )
});
export default McpLoading;